import { render, staticRenderFns } from "./salezgdetail.vue?vue&type=template&id=402dbb6f&scoped=true&"
import script from "./salezgdetail.vue?vue&type=script&lang=js&"
export * from "./salezgdetail.vue?vue&type=script&lang=js&"
import style0 from "./salezgdetail.vue?vue&type=style&index=0&id=402dbb6f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402dbb6f",
  null
  
)

export default component.exports